/**
 * Learner-facing player chrome — navigation, feedback, and shell labels (CEE-1129).
 *
 * Slide prose is translated via the authoring translation pipeline; these fixed UI strings
 * are pre-translated per `languages.code` and embedded in `course.js` at SCORM export.
 *
 * `chromeStrings.vectors.json` in this directory is the source of truth. The SCORM packager
 * carries a copy under `authoring-courses/src/lib/scorm/` — kept in sync by
 * `chromeStrings.test.ts` on both sides.
 */
import vectors from './chromeStrings.vectors.json';

export interface ChromeStrings {
  next: string;
  submit: string;
  tryAgain: string;
  continue: string;
  finish: string;
  backToModules: string;
  finishCourse: string;
  welcome: string;
  courseProgress: string;
  chooseLanguage: string;
  start: string;
  courseCompleted: string;
  loadFailed: string;
  loading: string;
  correctHeading: string;
  incorrectHeading: string;
  back: string;
  skipToContent: string;
  flipCardAction: string;
}

type ChromeStringsVectors = Record<string, ChromeStrings>;

const CHROME_STRINGS_BY_LANGUAGE: ChromeStringsVectors = Object.fromEntries(
  Object.entries(vectors).filter(([key]) => key !== '$comment'),
) as ChromeStringsVectors;

export const DEFAULT_CHROME_STRINGS: ChromeStrings = CHROME_STRINGS_BY_LANGUAGE['en-US'];

/** Fallback to en-US when a zip predates chrome strings or uses an unknown code. */
export function resolveChromeStrings(languageCode: string): ChromeStrings {
  return CHROME_STRINGS_BY_LANGUAGE[languageCode] ?? DEFAULT_CHROME_STRINGS;
}

export { CHROME_STRINGS_BY_LANGUAGE };
